import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { IDriverFilter } from "@interfaces/filters/IDriverFilter";
import { IGroupFilter } from "@interfaces/filters/IGroupFilter";
import { IDriver } from "@interfaces/IDriver";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { DriverService } from "@services/driver.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IFilterBar, IFilterBarFilter } from "../newResourceFilterBar.component";
import "./driverResourceFilter.scss";

interface IComponentBindings {
    selectedDriver: IDriver;
    driverId: number;
    groupFilter: IGroupFilter;
}

class ComponentController implements angular.IComponentController, IComponentBindings, IFilterBarFilter<IDriverFilter> {

    parent: IFilterBar;
    show = false;
    isDirty = false;

    filterName = "Drivers";
    filterLabel: string;
    filterTitle: string;
    filterIcon: string;
    showClearFilterButton = true;

    drivers: IDriver[];
    selectedDriver: IDriver;

    driverId: number;

    groupFilter: IGroupFilter;

    previousFilter: IDriverFilter;

    tableHeaders: IVeriTableHeader[];
    tableRows: IVeriTableRow<IDriver>[];

    onChange: (args: { filter: IDriverFilter }) => void;

    static $inject = ["$rootScope", "$element", "$timeout", "driverService", "translationService"];

    constructor(
        private readonly $rootScope: IRunBlockRootScope,
        public readonly $element: HTMLElement,
        private readonly $timeout: angular.ITimeoutService,
        private readonly driverService: DriverService,
        private readonly translationService: TranslationService) {
    }

    $onInit() {
        if (parent) {
            this.parent.registerFilter(this);
        }

        this.createTableHeaders();
    }

    $onDestroy() {
        this.show = false;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.updateFilterLabel();

        if (onChangesObj["driverId"]) {
            this.selectedDriver = null;
            this.getDrivers();
        }

        if (onChangesObj["groupFilter"]) {
            this.getDrivers();
        }
    }

    toggleFilter(show: boolean) {
        this.show = show;

        if (this.show) {
            this.getDrivers();
        }
    }

    selectedDriverChanged(driver: IDriver) {
        this.driverId = null;

        if (this.selectedDriver && this.selectedDriver.Id === driver.Id) {
            this.selectedDriver = null;
        } else {
            this.selectedDriver = driver;
        }

        this.updateFilterLabel();

        this.createFilterObject();

        this.$rootScope.$broadcast(BroadcastEvent.closeResourceFilterBar);
    }

    clearFilter() {
        this.selectedDriver = null;
        this.driverId = null;

        this.updateFilterLabel();
    }

    createFilterObject(): IDriverFilter {
        return {
            driver: this.selectedDriver
        };
    }

    // ------------------

    private createTableHeaders() {
        this.tableHeaders = [
            { title: this.translationService.t('Common.Name'), sortable: true }
        ];
    }

    private getDrivers() : angular.IPromise<void> {
        return this.driverService.getDrivers().then(drivers => {
            if (this.groupFilter && this.groupFilter.group) {
                drivers = drivers.filter(d => this.groupFilter.group.DriverIds.indexOf(d.Id) >= 0);
            }

            this.drivers = drivers;

        }).finally(() => {
            this.createTableRows();
            this.updateFilterLabel();
        });
    }

    private updateFilterLabel() {
        this.filterLabel = this.translationService.t('Common.Drivers');
        this.filterIcon = "person";

        if (this.drivers && this.driverId) {
            this.selectedDriver = this.drivers.find(driver => driver.Id === this.driverId);

            if (!this.selectedDriver) {
                this.driverId = null;
                this.onChange({ filter: this.createFilterObject() });
            }
        }

        if (this.selectedDriver) {
            this.filterLabel = this.selectedDriver.DisplayName;
        }

        this.isDirty = !!this.selectedDriver;
    }

    private createTableRows() {
        this.tableRows = [];

        this.drivers.forEach(driver => {
            this.tableRows.push({
                data: driver,
                cells: this.createTableCells(driver)
            });
        });
    }

    private createTableCells(driver: IDriver): IVeriTableRowCell[] {
        const cells: IVeriTableRowCell[] = [
            { contents: driver.DisplayName }
        ];

        return cells;
    }
}

export class DriverResourceFilterComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    require: { [index: string]: string; };
    template: string;

    constructor() {
        this.bindings = {
            selectedDriver: "<driver",
            driverId: "<?",
            groupFilter: "<?",

            show: "<",

            onChange: "&"
        };

        this.require = {
            parent: "^?newResourceFilterBar"
        };

        this.controller = ComponentController;
        this.template = require("./driverResourceFilter.html");
    }
}
